export default "__VITE_ASSET__BgWO8X3W__"